import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Femtoware Infotech';
const SITE_URL = 'https://femtowareinfotech.com';
const DEFAULT_DESCRIPTION =
	'Femtoware Infotech — custom software development, web & mobile apps, cloud solutions, and AI/ML services. We build scalable, modern technology solutions for businesses worldwide.';

interface SEOProps {
	title: string;
	description: string;
	path: string;
	image: string;
	type: string;
	jsonLd: Record<string, unknown> | undefined;
}

const SEO = ({
	title,
	description,
	path,
	image,
	type,
	jsonLd,
}: SEOProps) => {
	const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
	const canonicalUrl = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;

	const defaultJsonLd = {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: SITE_NAME,
		url: SITE_URL,
		logo: `${SITE_URL}/android-chrome-512x512.png`,
		description: DEFAULT_DESCRIPTION,
		contactPoint: {
			'@type': 'ContactPoint',
			contactType: 'customer service',
		},
		sameAs: [],
	};

	return (
		<Helmet>
			<title>{pageTitle}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={canonicalUrl} />

			{/* Open Graph */}
			<meta property="og:title" content={pageTitle} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={image} />
			<meta property="og:type" content={type} />
			<meta property="og:site_name" content={SITE_NAME} />

			{/* Twitter Card */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={pageTitle} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />

			{/* JSON-LD Structured Data */}
			<script type="application/ld+json">
				{JSON.stringify(jsonLd ?? defaultJsonLd)}
			</script>
		</Helmet>
	);
};

export default SEO;
